import defaultPreviewImage from '../assets/default-preview.png';

export const DEFAULT_PREVIEW_LINK = defaultPreviewImage;
